/**
 * Sprint V103 (Mo 21.09.2026) — Bestätigungsseite nach Konto-Löschung.
 *
 * Route: /gelöscht
 * Kein Rueckgewinnungs-CTA — bewusst emotional respektvoll und knapp.
 */
import React from "react";
import { Link } from "react-router-dom";
import { CheckCircle2 } from "lucide-react";

export default function AccountDeleted() {
  return (
    <div
      className="min-h-screen bg-slate-50 dark:bg-slate-950 flex items-center justify-center px-4 py-12"
      data-testid="account-deleted-page"
    >
      <div className="max-w-xl w-full text-center">
        <div className="mx-auto w-16 h-16 rounded-full bg-emerald-100 dark:bg-emerald-900/40 flex items-center justify-center">
          <CheckCircle2 className="w-8 h-8 text-emerald-600 dark:text-emerald-400" />
        </div>
        <h1
          className="mt-6 text-3xl sm:text-4xl font-extrabold text-slate-900 dark:text-white leading-tight"
          data-testid="account-deleted-headline"
        >
          Dein Konto wurde vollständig entfernt.
        </h1>
        <p className="mt-4 text-base sm:text-lg text-slate-700 dark:text-slate-300 leading-relaxed">
          Alle Daten sind aus unseren Systemen gelöscht. Du bekommst keine
          E-Mails mehr — weder Nurture-Impulse noch Webinar-Reminder noch
          Video-Drip.
        </p>
        <p className="mt-4 text-sm text-slate-500 dark:text-slate-400">
          Danke, dass du eine Zeit lang dabei warst.
        </p>
        <div className="mt-8 pt-6 border-t border-slate-200 dark:border-slate-800 text-xs text-slate-400 dark:text-slate-500">
          <Link to="/" className="underline hover:text-slate-600 dark:hover:text-slate-300">
            Zur Startseite
          </Link>
        </div>
      </div>
    </div>
  );
}
